import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchCategories = () => api.get("/services/categories").then((r) => r.data);
export const fetchStaff = () => api.get("/staff").then((r) => r.data);
export const fetchReviews = () => api.get("/reviews").then((r) => r.data);
export const fetchStudio = () => api.get("/studio").then((r) => r.data);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const fetchAvailability = (date) => api.get(`/availability?date=${date}`).then((r) => r.data);
export const rescheduleBooking = (id, token, date, time) => api.post(`/bookings/${id}/reschedule`, { token, date, time }).then((r) => r.data);
export const adminListBookings = () => api.get("/admin/bookings").then((r) => r.data);
export const adminUpdateBooking = (id, status) => api.patch(`/admin/bookings/${id}`, { status }).then((r) => r.data);
